import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

export default async (params: any, id: any) => {
  const token = getToken();

  let valid = false;
  let data = {};
  let editResult;

  if (token) {
    try {
      let response = await fetch(
        `${BASE_URL}/api/construction_diesel_volumes/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(params),
        }
      );

      editResult = await response.json();
      valid = editResult && editResult.success;
      let constVol = editResult;

      data = constVol;
      if (constVol.fossil && constVol.hvo) {
        data = {
          ...constVol,
          fossil: parseFloat(constVol.fossil),
          hvo: parseFloat(constVol.hvo),
        };
      }
    } catch (except) {
      valid = false; // network error
    }
  }

  if (!valid) {
    if (editResult && editResult.errors) {
      return {
        valid: false,
        message: editResult.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    data,
  };
};
